import { ACCESSORY_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS } from './catalog-descriptions-accessories';
import { APPAREL_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS } from './catalog-descriptions-apparel';
import { HOME_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS } from './catalog-descriptions-home';
import { OBJECT_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS } from './catalog-descriptions-objects';
import { VEHICLE_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS } from './catalog-descriptions-vehicles';

const PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS: Record<string, string> = {
  ...APPAREL_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS,
  ...ACCESSORY_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS,
  ...HOME_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS,
  ...OBJECT_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS,
  ...VEHICLE_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS,
};

export function getProductPresetSubtypeDescription(
  parentKey: string,
  subtypeId: string
): string {
  const description =
    PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS[`${parentKey}/${subtypeId}`];
  if (!description) {
    throw new Error(`Missing description for ${parentKey}/${subtypeId}`);
  }
  return description;
}
